import { Box, Typography } from "@mui/material";
import { useWallets } from "api/wallets";
import { useMessage } from "hooks/intl";
import {
  CampaignConditionNewFormat,
  TransactionItemFilterType,
} from "types/campaigns";
import { useStyles } from "../../ConditionReadOnly";

interface Props {
  conditionObject: TransactionItemFilterType | CampaignConditionNewFormat;
}

export const WalletReadOnlyParam = ({ conditionObject }: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const { useWalletTypeList } = useWallets();
  const walletTypeCode = (conditionObject as CampaignConditionNewFormat).value
    .params?.walletTypeCode;
  const { data: wallets } = useWalletTypeList({
    filters: [
      {
        condition: "eq",
        query: "code",
        value: walletTypeCode as string,
      },
    ],
  });

  const walletTypeName = wallets?.items.find(
    (wallet) => wallet.code === walletTypeCode,
  )?.name;

  return (
    <>
      <Typography>{message({ id: "in" }).toLowerCase()}</Typography>
      <Box className={classes.box}>{walletTypeName}</Box>
    </>
  );
};
